import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertDistance',
  standalone: true
})
export class ConvertDistancePipe implements PipeTransform {

  transform(value: unknown): number | null {
    if (typeof value !== 'number' || isNaN(value)) {
      return null;
    }
    // 1 mile = 0.868976 nautical miles
    const nauticalMiles = value * 0.868976;
    return +nauticalMiles.toFixed(1);
  }

}
